import { XCard } from '@adornis/chemistry/elements/components/x-card.js';
import { customElement } from 'lit/decorators.js';

@customElement('tr-card')
export class TrCard extends XCard {
  override styles() {
    return [
      ...super.styles(),
      {
        ':host > tr-link': {
          color: 'unset',
          'text-decoration': 'unset',
        },
      },
    ];
  }
}
